module.exports = __webpack_public_path__ + "img/step5-04.e151ff51.jpg";